import React from "react";
import PageHeader from "../Page/page_header";
import PageStatisticsHeader from "../Page/page_statistics_header";
import StatisticsContextProvider from "./statistics_context";
import GraphWithOptions from "./graph_with_options";
import FourGraph from "./four_graph";
import StatisticsData from "./statistics_data";
import "./statistics.css";
import FeedbackTable from "../Games/feedback_table";
import { useIsMobile } from "../../hooks/use-mobile";

const StatisticsPage = ({ title, header, game_id }) => {
  const isMobile = useIsMobile();

  return (
    <StatisticsContextProvider>
      <div className={`default_page_style items-center statistics-container dark:text-white ${isMobile ? 'px-4' : ''}`} 
           style={{
             width: isMobile ? '100vw' : '92.5vw', 
             padding: isMobile ? '2rem 1rem' : '4.5vw 0vw'
           }}>
        <PageHeader title={header || title} />
        <PageStatisticsHeader game_id={game_id} />
        <div className={`mb-8 mt-4 ${isMobile ? 'mb-4 mt-2' : ''}`} style={{width: isMobile ? '100%' : '87.5vw'}}>
          <GraphWithOptions game_id={game_id} />
        </div>
        <div className={`mb-8 statistics-row ${isMobile ? 'mb-4' : ''}`} 
             style={{width: isMobile ? '100%' : '87.5vw'}}>
          {isMobile ? (
            <div className="four-graph-scroll-mobile">
              <FourGraph game_id={game_id} />
            </div>
          ) : (
            <FourGraph game_id={game_id} />
          )}
          <StatisticsData game_id={game_id} />
        </div>
        <FeedbackTable game_id={game_id}/>
      </div>
    </StatisticsContextProvider>
  );
};

export default StatisticsPage; 